import { format } from 'date-fns';
import { dateFormat } from 'constants/formats';
import exportFromJSON from 'export-from-json';

export const exportExcel = ({ data, fileName }) => {
  if (!data?.length) return;

  const exportType = exportFromJSON.types.xls;

  const parsedFileName = fileName.replace(/ /g, '_');

  const dataConverted = data.map((row) => {
    const currentRow = {};

    Object.entries(row).forEach(([key, value]) => {
      if (typeof value === 'number') {
        currentRow[key] = value.toString().replace('.', ',');
      } else if (value instanceof Date) {
        currentRow[key] = format(new Date(value), dateFormat);
      } else {
        currentRow[key] = value;
      }
    });

    return currentRow;
  });

  exportFromJSON({
    data: dataConverted,
    fileName: parsedFileName,
    exportType,
  });
};
